import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface CampaignLoadingOverlayProps {
    isVisible: boolean;
    message?: string;
}

export function CampaignLoadingOverlay({
    isVisible,
    message = 'Loading campaign...',
}: CampaignLoadingOverlayProps) {
    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm flex items-center justify-center"
                >
                    <motion.div
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.8, opacity: 0 }}
                        className="bg-white/10 backdrop-blur-xl rounded-2xl p-8 border border-white/20 flex flex-col items-center"
                    >
                        {/* Animated loading spinner */}
                        <div className="relative mb-4">
                            <motion.div
                                animate={{ rotate: 360 }}
                                transition={{
                                    duration: 1,
                                    repeat: Infinity,
                                    ease: 'linear',
                                }}
                                className="w-12 h-12 border-3 border-purple-500/30 border-t-purple-500 rounded-full"
                            />
                            <motion.div
                                animate={{ rotate: -360 }}
                                transition={{
                                    duration: 1.5,
                                    repeat: Infinity,
                                    ease: 'linear',
                                }}
                                className="absolute inset-0 w-12 h-12 border-3 border-pink-500/20 border-b-pink-500 rounded-full"
                            />
                        </div>

                        {/* Loading message */}
                        <motion.p
                            animate={{ opacity: [0.6, 1, 0.6] }}
                            transition={{
                                duration: 2,
                                repeat: Infinity,
                                ease: 'easeInOut',
                            }}
                            className="text-white font-medium text-center"
                        >
                            {message}
                        </motion.p>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export default CampaignLoadingOverlay;
